import { poiLayers } from "../../component/content/layer";

const poiList = [
  {
    value: 'admCenter',
    name: '행정복지센터',
    type: 4,
    layer: 'sph_grid_adm',
    layerName: poiLayers.admCenter
  },
  {
    value: 'university',
    name: '대학교',
    type: 1,
    layer: 'sph_grid_univ',
    layerName: poiLayers.university
  },
  {
    value: 'industry',
    name: '산업단지',
    type: 2,
    layer: 'sph_grid_ids',
    layerName: poiLayers.industry
  },
  {
    value: 'hospital',
    name: '병·의원',
    type: 5,
    layer: 'sph_grid_hos',
    layerName: poiLayers.hospital
  },
  {
    value: 'security',
    name: '경찰서',
    type: 3,
    layer: 'sph_grid_police',
    layerName: poiLayers.security
  },
];

const distanceList = [
  {
    name: '500m',
    target: 'b_500'
  },
  {
    name: '750m',
    target: 'b_750'
  },
  {
    name: '1km',
    target: 'b_1000'
  },
  {
    name: '5km',
    target: 'b_5000'
  },
  {
    name: '10km',
    target: 'b_10000'
  },
]

export { poiList, distanceList };